import FormWithControls from 'app/shared-components/FormWithControls'
import {
    RequestConfig,
} from 'app/types/request.types'
import {
    HsCode,
} from 'app/Apps/OrderManagement/ProformaInvoices/HsCode/HsCode.types'

import getFields from './HsCodeForm.fields'

type HsCodeFormProps = {
    data?: HsCode,
    onSuccess?: (...args: any[]) => void,
    onCancel?: (...args: any[]) => void,
    request?: RequestConfig,
    disabled?: boolean,
}
const defaultProps: Partial<HsCodeFormProps> = {
    data: {} as HsCode,
    onSuccess: undefined,
    onCancel: undefined,
    disabled: false,
}

export default function HsCodeForm({
    data,
    onSuccess,
    onCancel,
    request,
    disabled,
}: Readonly<HsCodeFormProps>) {
    return (
        <FormWithControls
            name="HsCodeForm"
            value={data}
            fields={getFields()}
            exists={Boolean(data?.id)}
            onSuccess={onSuccess}
            onCancel={onCancel}
            requestParams={request}
            disabled={disabled}
        />
    )
}

HsCodeForm.defaultProps = defaultProps
